// extracted by mini-css-extract-plugin
export default {"row":"TlJJE0VRIxLfj2cpIY4l"};